import Vue from 'vue';
import UniqueId from 'vue-unique-id';
import $ from 'jQuery';
import setupValidation from './utils/validation'
import OilFinder from './components/oilfinder/Index.vue';
import BuyEnergyHeader from './components/buyenergyheader/Index.vue';
import BuyEnergyForm from './components/BuyEnergyForm/Index.vue';
import BuyEnergyHeaderInContent from './components/BuyEnergyHeaderInContent/Index.vue';

//register components
Vue.component('migrol-oilfinder', OilFinder);
Vue.component('migrol-buy-energy-form', BuyEnergyForm);
Vue.component('migrol-buyenergyheader', BuyEnergyHeader);
Vue.component('migrol-buyenergyheader-incontent', BuyEnergyHeaderInContent);

Vue.config.productionTip = false; //disable prod tooltip

//import the unique id plugin (see https://www.npmjs.com/package/vue-unique-id) -> we have to change the uid property to uid2 bcs vue-select is using uid already....
Vue.use(UniqueId, { uidProperty: 'uid2' });

//figure out language of current page
var language = document.querySelector('html').lang;
switch (language) {
    case "de":
    case "fr":
    case "it":
        break;
    default:
        language = "de";
        break;
}

//define a global mixin with a language property
Vue.mixin({
    data: function () {
        return {
            get language() {
                return language;
            }
        }
    }
});

$.getJSON('/migrolapi/' + language + '/contentUI').done((data) => {

    //setup validation
    setupValidation(language, data.ValidationMessages);

    //mount app on all migrol-content-app elements
    document.querySelectorAll('.migrol-content-app').forEach((app) => {
        new Vue({
            el: app
        });
    });
});

export default {}